import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { clearAuthStorage } from "./Login/LoginPage";

const SESSION_FLAG = "activeSession";

const AuthGuard = () => {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const hasTenant = !!localStorage.getItem("tenantName");
    const hasActiveSession = sessionStorage.getItem(SESSION_FLAG) === "1";

    if (hasTenant && hasActiveSession) {
      setStatus("valid");
    } else {
      if (hasTenant && !hasActiveSession) {
        clearAuthStorage();
      }
      setStatus("invalid");
    }
  }, []);

  if (status === "checking") return null;
  if (status === "invalid") return <Navigate to="/" replace />;

  return <Outlet />;
};

export default AuthGuard;
